import { hasAnyRole } from "../../utils/auth";
import { ROLES } from "../../auth/roles";

/*
 * Who may change scholarships. The DG and the Minister see every scholarship screen the
 * Scholarship Admin sees, read-only (decision of 15 October 2026); the API refuses their changes.
 */
export const canManageScholarships = () => hasAnyRole(ROLES.ADMIN);

// Shown where a reader would otherwise find the change controls
export const READ_ONLY_NOTE = "Read-only: only the Scholarship Admin changes scholarships.";

// The set-up (details, programmes, documents, eligibility) changes while a draft, or once published until a student starts applying, unsent applications included
export const setUpOpen = (s) => s.state === "DRAFT" || (s.state === "PUBLISHED" && !s.applicationsStarted);
export const canEditSetUp = (s) => canManageScholarships() && setUpOpen(s);
// After publishing every change needs a reason (a draft needs none)
export const needsReason = (s) => s.state !== "DRAFT";
